export class InputBuffer {
  private buffered: { action: string; timestamp: number; binding?: 'action' | 'action2' | 'action3' } | null = null;

  bufferInput(action: string, timestamp: number, binding?: 'action' | 'action2' | 'action3'): void {
    this.buffered = { action, timestamp, binding };
  }

  consumeBuffer(currentTime: number, windowSeconds: number): { action: string; binding?: 'action' | 'action2' | 'action3' } | null {
    if (!this.buffered) return null;

    const elapsed = currentTime - this.buffered.timestamp;
    if (elapsed <= windowSeconds && elapsed >= 0) {
      const buffered = this.buffered;
      this.buffered = null;
      return { action: buffered.action, binding: buffered.binding };
    }

    this.buffered = null;
    return null;
  }

  hasBufferedInput(): boolean {
    return this.buffered !== null;
  }

  clear(): void {
    this.buffered = null;
  }
}
